/**
 * The balance an agreement was written against: the account balance when the
 * plan was created (clients_payment_plans.initial_balance), as its PDF and
 * offer discount use. The account's current balance moves on afterwards, so
 * showing it put the wrong number on older (e.g. canceled) agreements. 0 and
 * negative balances are real; only a missing value falls back.
 */
export const getAgreementBalance = (
  initialBalance: unknown,
  accountBalance: unknown
) => {
  if (
    initialBalance === null ||
    initialBalance === undefined ||
    initialBalance === ""
  ) {
    return accountBalance;
  }
  const balance = Number(initialBalance);
  return Number.isFinite(balance) ? balance : accountBalance;
};
